import { jsx, jsxs } from "react/jsx-runtime";
import { inputSelectVariants } from "./InputSelect.variants.js";
import { CdnIcon } from "../CdnIcon/index.js";
function InputSelect({ labelText, options, name, defaultValue = options[0].value, onChange, size, ...restProps }) {
    const { root, labelSlot, dropdownIcon, selectBox, selectBoxWrapper } = inputSelectVariants({
        size
    });
    return /*#__PURE__*/ jsxs("div", {
        className: root(),
        "data-testid": "input-select-component",
        children: [
            labelText ? /*#__PURE__*/ jsx("label", {
                htmlFor: name,
                className: labelSlot(),
                children: labelText
            }) : null,
            /*#__PURE__*/ jsxs("div", {
                className: selectBoxWrapper(),
                children: [
                    /*#__PURE__*/ jsx("select", {
                        id: name,
                        name: name,
                        defaultValue: defaultValue,
                        onChange: onChange,
                        className: selectBox(),
                        ...restProps,
                        children: options.map((option)=>/*#__PURE__*/ jsx("option", {
                                value: option.value,
                                children: option.label
                            }, option.value))
                    }),
                    /*#__PURE__*/ jsx(CdnIcon, {
                        iconName: "arrow_drop_down",
                        className: dropdownIcon(),
                        size: "20"
                    })
                ]
            })
        ]
    });
}
export { InputSelect };
